import { useAtom, type WritableAtom } from "jotai";
import { appStore } from "../store";
import dayjs from "dayjs";
import { addonFlowStartedAtom, addonsPassengerListAtom, alreadyAddonsLegPassengerAtom, alreadyAddonsLegPassengerTotalAtom, bookingLegWiseAddonsForCancelTripAtom, carriedOverAddonsAtom, changeDateCarryOverSnapshotAtom, confirmAddonsPassengerListAtom, manageAddonsNewConfirmedAddonsAtom, manageAddonsRemovedAddonsAtom, manageSeatingBaselineAddonsLegPassengerAtom, mealPreferencesResponseAtom, patchAddonsOnConfirmAtom, pendingRefundFulfillmentIdsAtom, refundOffersByFulfillmentIdAtom, selectedLegAddonsPriceAtom, showAddonsModalAtom } from "../AddonsAtoms";
import { contentDetailAtom } from "../CmsConfirmationContentAtom";
import { cmsAboutPassDetailAtom, cmsAccountBannerAtom, cmsMonthlyPassOfferResponseAtom, cmsOfferDetailAtom, cmsOfferListAtom, cmsSpecialFareOfferDetailResponseAtom, cmsSpecialFareOfferResponseAtom, cmsTravelPassOfferResponseAtom } from "../CMSOffersAtom";
import { activeCompanyActionAtom, activitiesSectorsAtom, citiesAtom, corporateDataAtom, corporateFormSubmittedAtom, corporateLoadErrorAtom, corporateLoadingAtom, corporateUsersAtom, corporateUsersLoadErrorAtom, corporateUsersTotalAtom, companyBookingsAtom, companyBookingsTotalAtom, companyBookingsLoadingAtom, companyBookingsLoadErrorAtom, requestCorporateAccountDetailsAtom } from "../corporateAccountAtoms";
import { authLoadedStateAtom, calendarDayIntervalAtom, cmsProductFeatureListAtom, cmsServiceClassFeatureListAtom, contactCategoriesAtom, cookieConsentBannerVisibleAtom, cookieConsentGivenAtom, cookieManagementModalVisibleAtom, cookiePreferencesAtom, corporateAccountFlowStartedAtom, getAppBanner, inboundOfferIdAtom, inboundSearchStateAtom, initializedStateAtom, isAnonymousStateAtom, isAuthCheckCompleteStateAtom, isAuthenticatedStateAtom, isBookReturnJourneyAtom, isChangeDateStateAtom, isHyperFastStateAtom, isQuickExchangeStateAtom, outboundOfferIdAtom, quickExchangeTripDirectionAtom, searchStateAtom, searchStatePopupAtom, selectCorporateAccountFaqAtom, selectedDateRangeStateAtom, selectedMenuAtom, selectedRangeStateAtom, selectFaqAtom, selectFaqLoading, selectOsInfo, sliderStationFacilitiesDataStateAtom, tokenStateAtom, userProfileStateAtom } from "../atoms";
import { activeBookingTabAtom, autoSuggestionListAtom, bookedNextTripsAtom, bookedTripsAtom, bookingConfirmStatusAtom, bookedJourneyCommentAtom, journeyPlannerStateAtom, bookingRequestAtom, bookingResponseAtom, bookingScopeAtom, bookingDetailsRefreshTokenAtom, bookingResponseListAtom, bookingsListPaginationAtom, cancelBookingConfirmPopupFlagAtom, defaultActiveKeyForTripSummaryAtom, displayPassengerDataAtom, guestCheckoutBookingIdAtom, inboundProductCodeAtom, inboundSelectedChangeDateAtom, inboundSelectedDateAtom, isModalVisibleAtom, isPastBookingDetailsAtom, isRetrieveModalOpenAtom, isRoundTripInboundModalVisibleAtom, isRoundTripModalVisibleAtom, isShuttleChangeDateAtom, lastMonthAtom, mealResponseAtom, modificationNotAllowedBookingIdsAtom, originalPriceOfExchangedItemsInboundAtom, originalPriceOfExchangedItemsOutboundAtom, outboundProductCodeAtom, pendingBookingDataAtom, quickExchangeBookingResponseAtom, refundableAmountAtom, refundFeeAtom, refundOfferResponseAtom, refundQuoteFailedAtom, repeatedBookingAtom, retrieveFormAtom, searchPopupDataAtom, selectedBookingForBookItAgainAtom, selectedBookReturnJourneyDateAtom, selectedChangeDateAtom, selectedInboundTrainStateAtom, SelectedOfferIdChangeDateAtom, selectedTripsDataAtom, bookedCommentsResponseAtom, showRetrieveBookingAtom, ticketOptionsAtom, journeyPlannerTrainTypeTabAtom, bookingPaymentDataAtom, seatingPreferencesAtom, appliedPassengerPassAtom, upcomingMultiBookingTripsAtom, pastMultiBookingTripsAtom } from "../BookingAtom";
import { calendarBestPriceAtom, calendarRangeBestPriceAtom, calendarStateAtom, dateSelectedFromCalendarAtom, isDateOfferCheckDoneAtom, markSelectedDateAsDisableAtom, markSelectedDateAsSoldOutAtom, offerCalendarBestPriceAtom, popularTripsPriceAtom, selectedDatePriceAtom } from "../CalendarAtom";
import { cmsPLaceDetailAtom, bannerListResponseAtom, destinationDetailAtom, destinationResponseAtom, newsDetailResponseAtom, newsListResponseAtom, routesResponseAtom, trustBuildersResponseAtom, usefulInformationAtom, cmsAppDownloadLinkResponseAtom, appDownloadLinkAtom, enhancedTripsResponseAtom, favouriteTripsForTodayResponseAtom, favouriteDeparturesForTodayResponseAtom, enhancedTripDetailAtom, popularTripsForHomePageAtom, bestPriceAvailableOriginsAtom, usefulInfoDetailAtom, departureFromTripsAtom, todayTrainFromTripsAtom, cmsStopsAtom, newsLoadedAtom, routesLoadedAtom, popularTripsLoadedAtom, popularDestinationsLoadedAtom } from "../CmsDestinationAtom";
import { countryCodesAtom } from "../CountryAtom";
import { fulfillmentResponseAtom } from "../FulfillmentResponse";
import {
  languageDropdownOpenAtom,
  languagesResponseAtom,
  localeLanguageAtom,
} from "../LanguagesAtom";
import { selectedTrainLegsAtom, tripLegsDetailsAtom } from "../legTrainAtom";
import { carRentalLocationsAtom, carRentalModeAtom, carRentalResultsStatusAtom, carRentalSearchStateAtom, carRentalV2SegmentsAtom, endToEndSelectedTripAtom, rideEstimatesAtom, rideHailingDisabledAtom, rideHailingModeAtom, rideLocationPickerAtom, rideResultsStatusAtom, rideSearchStateAtom, shuttleAddedAtom, shuttleAddRequestAtom, shuttleBusModeAtom, shuttleMinPriceCacheAtom, shuttleStopAvailabilityAtom, refundedShuttleOfferIdsAtom, shuttleOffersStatusAtom, shuttleSelectionAtom, shuttleStopsAtom, shuttleTripsAtom, nolCardModeAtom, nolSelectionAtom, nolAddedAtom, nolOffersAtom } from "../EndToEndJourneyAtom";
import { networkDetailResponseAtom, networkMapStationInfoResponseAtom, networkMapStationResponseAtom } from "../NetworkMapStationsAtom";
import { privacyPolicyContentResponseAtom } from "../PrivacyPolicyAtom";
import { currentLocationAtom, fetchingFmlmViewInformationAtom, fmlmFavouriteLocationAtom, fmlmFilterAtom, fmlmJourneyResponseAtom, fmlmReverseGeoCodeLocationAtom, fmlmSubStationDropdownAtom, fmlmViewInformationAtom, fmlmViewOffersMapAtom, isDepartureDateChangedAtom, isTimerVisibleAtom, isFmlmFilterTimerModelOpenAtom, lastFmlmFetchOfferDateAtom, locationDataAtom, locationMapVisibleAtom, locationPermissionStateAtom, selectedFmlmJourneyAtom, selectedLocationAtom, selectedLocationDestinationAtom, selectedInboundFmlmJourneyAtom, isFmlmInboundTimeModalOpenAtom, allFmlmJourneyAtom } from "../LocationAtom";
import { accountActionAtom, accountProgressAtom, activeAccountActionAtom, bookingsSearchResponseAtom, experienceFieldsAtom, favoriteDepartureFieldsAtom, favoriteTripsForTodayFieldsAtom, generalFieldsAtom, isOtpVerifiedAtom, isPassengerDropdownOpenAtom, isPersonalInfoFormValidAtom, isPersonalInfoModifiedAtom, isSelectingDestinationAtom, isSelectingOriginAtom, manageIncludeWidgetsAtom, manageWidgetsAtom, multiBookingPreferenceBackToAtom, otpErrorAtom, personalizeExperienceActiveTabAtom, phoneVerificationResponseAtom, showInvoiceDetailsAtom, specialAssistancePrefAtom, subActiveAccountActionAtom, travelsDaysAtom } from "../MyAccount";
import { allPassengerPriceAndAgeGroupAtom, allPassengerPriceAndAgeGroupInBoundAtom, alreadyPaidInBoundAtom, alreadyPaidOutBoundAtom, availableDatesAtom, cancelBookingPreviousRouteAtom, upgradePreviousRouteAtom, customerLoyaltyTierRateAtom, earnExtraPointsAtom, earnPointsAtom, earnPointsInboundAtom, earnPointsOutboundAtom, earnPointsTotalAtom, exchangeOffersAtom, filterStateAtom, filterTrainsAtom, initialTrainClassSelectionAtom, isPremiumPrivacySeatingCheckedAtom, isStandardPrivacySeatingCheckedAtom, loyaltyTiersAtom, offerAtom, offerPassTypeAtom, offersPageViewAtom, offersRequestAtom, openSearchModalAtom, originalTrainClassSelectionAtom, outboundShuttleOfferIdAtom, passBookingsAtom, passengerSpecificationsTypesAtom, passFormValuesAtom, passOfferResponseAtom, paymentInboundAtom, paymentInboundItemsDetailsAtom, paymentInboundRefundAtom, paymentOutboundAtom, paymentOutBoundItemsDetailsAtom, paymentOutboundRefundAtom, selectedBookingIdForBookReturnJourneyAtom, selectedBookingIdForCancelAtom, selectedBookingIdForDateChangeAtom, selectedBookingTripStatusAtom, selectedCmsPassOfferAtom, selectedDateAtom, selectedInboundTrainAtom, selectedOfferIdAtom, selectedOutboundTrainAtom, selectedServiceClassAtom, selectedPassBookingAtom, selectedPassengerForDateChangeAtom, selectedPassengerForDateChangeInBoundAtom, selectedPassengersInBoundAtom, selectedPassOfferAtom, selectedShuttleOfferIdAtom, selectedTrainStateAtom, startIndexDateSelectorAtom, testStringAtom, ticketTypeStateAtom, trainAtom, trainTypeAtom, tripDisableForCancelSelectionAtom, tripDisableForDateChangeSelectionAtom, upgradeInboundOffersAtom, upgradeOutboundOffersAtom, visibleTrainsAtom, selectedStandardPrivacySeatingInboundAtom, selectedPremiumPrivacySeatingOutboundAtom, selectedPremiumPrivacySeatingInboundAtom, selectedStandardPrivacySeatingOutboundAtom, selectedPassengersOutBoundAtom, loyaltyProgramResponseAtom, tiersConfigAtom } from "../OfferAtoms";
import { areAllPassengerDetailsCompleteAtom, changeTripAlreadyPaidAddonsAtom, checkoutUserDataAtom, customerContactStateAtom, passengerMappingAtom, passengerSeatCursorAtom, passengerStateAtom, passengerTypesStateAtom, savedPassengerDetailAtom, selectedPassengerForCancelAtom, selectedPassengerForCancelInBoundAtom, selectedPassengersAtom, selectedPassengersPerTypeStateAtom } from "../PassengerAtoms";
import { carLicensePlateAtom, checkoutPaymentSummaryAtom, paymentCardsAtom, paymentStateAtom, paymentSubmittingAtom, paymentSuccessModalAtom, saveCardAtom, termsAgreedAtom } from "../PaymentAtom";
import { coachLayoutResponseAtom, confirmedSeatsAtom, floorPlanIconsResponseAtom, initiallyAvailableSeatsAtom, isManageSeatingAtom, originalSeatsAtom, placeMapResponseAtom, seatSelectorOpenAtom, seatServiceClassAtom, seatTravelClassAtom, seatsChangedOnCheckoutAtom, selectedCoachAtom, selectedSeatsAtom, unavailableSeatsAtom } from "../SeatingAtom";
import { actionTypeAtom, activeTicketAtom, additionalFieldsAtom, lastVisitedPageForServiceRequestAtom, modifiedPassengerNameAtom, openActionModalAtom, openCommentAtom, saveServiceRequestResponseAtom, selectedCategoryAndSubCategoryAtom, selectedTripForServiceRequestAtom, serviceCategoriesAtom, serviceRequestFormDataAtom, serviceRequestModalAtom, serviceRequestTicketListAtom, submitRequestButtonDisabledAtom, subServiceCategoriesAtom } from "../ServiceRequestAtom";
import { inboundShuttleState, isAddShuttleAtom, outboundShuttleState, trainShuttleBookingAtom } from "../ShuttleAtom";
import { isAddShuttleFlowAtom, shuttleBookedOffersAtom } from "../ShuttleBookedOffersAtom";
import { selectedShuttlesAtom } from "../SelectedShuttlesAtom";
import { favoritesStateAtom, stopsResponseAtom, subStationDropdownAtom, updatedStopsAtom } from "../StopsAtoms";
import { termsofUseContentResponseAtom } from "../TermsOfUseAtom";
import {
  currentLegIndexTicketAtom,
  currentOfferIndexTicketAtom,
  currentPassengerTicketAtom,
  modalStateRequestInvoiceAtom,
  modalStateTicketAtom,
} from "../TicketAtom";
import {
  nextAndPreviousTrainAtom,
  selectedTripForBookItAgainAtom,
  tripOfferAtom,
} from "../TripAtom";
import { userDataAtom } from "../UsersAtom";
import { listOfAppliedVoucherAtom, voucherCodeAtom, voucherDataAtom, voucherDetailAtom, voucherErrorAtom } from "../VoucherAtom";
import { listOfAppliedPromoCodeAtom, promoCodeErrorAtom } from "../PromoCodeAtom";
import {
  loyaltyProgramDataAtom,
  cmsAboutLoyaltyProgramResponseAtom,
  loyaltyCardHandleSelectActionAtom,
  customerTiersDataAtom,
} from "../LoyaltyProgramDataAtom";
import { isUpgradeToPremiumStateAtom } from "../UpgradePremiumAtom";
import { whitelistedAtoms, extendedExpiryAtoms } from "../WhitelistedAtoms"
import { journeyPlannerContentAtom, journeyPlannerStationAtom } from "../CmsJourneyPlannerAtom";
import { cmsGroupBookingAtom } from "../CmsGroupBookingAtom";
import { isMultiBookingStateAtom, multiBookingChangeTrainOffersAtom, multiBookingFormValuesAtom, multiBookingOfferResponseAtom, multiBookingRefundSummaryAtom, multiBookingSelectedTrainsAtom, multiBookingTravelDatesAtom } from "../MultiBookingAtom";

import { trainScheduleDataAtom } from "../TrainScheduleDataAtom";

/**
 * When true, `updateRecoilState` skips persisting atoms to localStorage.
 * Set during logout so a write racing the storage purge cannot re-populate it.
 */
let _suppressLocalStorageWrites = false;

export const suppressLocalStorageWrites = () => {
  _suppressLocalStorageWrites = true;
  // Safety net: re-enable after 10s in case redirect fails
  setTimeout(() => { _suppressLocalStorageWrites = false; }, 10000);
};

export const resetLocalStorageWrites = () => {
  _suppressLocalStorageWrites = false;
};

// Local storage utility functions
export const STORAGE_PREFIX = 'recoil_state_';

/**
 * Atom state is persisted to sessionStorage, NOT localStorage.
 *
 * It used to be localStorage, which outlives the tab. The persisted set is not
 * innocuous: `tokenStateAtom` is a bearer token, and `IUserResponse`
 * (userDataAtom / checkoutUserDataAtom) carries email, phone, birthdate and
 * invoicing address, while `IPassenger` (passengerStateAtom) carries names,
 * dates of birth and `prmNeeds` — accessibility/health data. All of it sat
 * readable on a shared or public machine long after the user walked away, and
 * the 30-minute TTL did not help because expiry is only enforced when an atom
 * is READ.
 *
 * sessionStorage is per-tab and dies with it, while still surviving everything
 * the app actually needs: a refresh, and the full MPGS round-trip including the
 * `/checkout/cancel` -> `/checkout` reload (same tab, so the store persists).
 *
 * Consequence, accepted deliberately: a booking flow no longer survives a
 * browser restart, and a second tab starts fresh instead of inheriting the
 * current flow. The latter was a source of cross-flow bleed, not a feature.
 */
const storage = (): Storage => sessionStorage;

const scopedKeys = (store: Storage): string[] => {
  const keys: string[] = [];
  for (let i = 0; i < store.length; i++) {
    const key = store.key(i);
    if (key?.startsWith(STORAGE_PREFIX)) keys.push(key);
  }
  return keys;
};

/**
 * Remove every `recoil_state_*` entry from BOTH stores.
 *
 * localStorage is included because that is where this data used to live. A user
 * who logs out after upgrading would otherwise keep their pre-upgrade token and
 * passenger details sitting in localStorage forever — nothing reads those keys
 * any more, so nothing would ever clean them up.
 */
export const purgeAllRecoilStateFromLocalStorage = (): void => {
  for (const store of [sessionStorage, localStorage]) {
    try {
      scopedKeys(store).forEach((key) => store.removeItem(key));
    } catch {
      // store unavailable (private mode); nothing to purge.
    }
  }
};

/**
 * One-time sweep of the pre-sessionStorage entries. Called at boot.
 *
 * Without this the migration leaks: the token and passenger PII written by the
 * old build stay in localStorage indefinitely, unread and unexpired, which is
 * the exact exposure this change is meant to close.
 */
export const purgeLegacyLocalStorageState = (): number => {
  try {
    const doomed = scopedKeys(localStorage);
    doomed.forEach((key) => localStorage.removeItem(key));
    return doomed.length;
  } catch {
    return 0;
  }
};
/**
 * Reclaim space when localStorage is full.
 *
 * Entries carry `expiresAt`, but nothing ever sweeps them: expiry is checked
 * only when an atom is READ, so a 3 MB `offerAtom` from a search two hours ago
 * sits there until someone reads that atom again. On a long-lived tab the quota
 * (~5 MB) fills, `setItem` throws, and every subsequent write is dropped —
 * silently, because the catch below only warns. Observed on INT 2026-08-25:
 * `offerAtom` alone held 3.0 MB of the 3.6 MB used, with tripOfferAtom and
 * filterTrainsAtom failing to persist.
 *
 * Two passes, cheapest first:
 *  1. drop everything already expired — pure garbage, no behaviour change;
 *  2. still no room? drop the LARGEST other persisted atoms until the write
 *     fits. Those are re-fetchable (search results, seat maps) and the write
 *     being attempted now is the fresher fact. The key being written is never
 *     a candidate.
 */
const parseExpiry = (raw: string | null): number | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed?.expiresAt === "number" ? parsed.expiresAt : null;
  } catch {
    return null;
  }
};

const recoilStateKeys = (): string[] => scopedKeys(storage());

/** Drop every persisted atom whose own `expiresAt` has passed. */
export const evictExpiredRecoilState = (now = Date.now()): number => {
  const doomed = recoilStateKeys().filter((key) => {
    const expiresAt = parseExpiry(storage().getItem(key));
    return expiresAt !== null && now > expiresAt;
  });
  doomed.forEach((key) => storage().removeItem(key));
  return doomed.length;
};

/** Drop the biggest persisted atom other than `keepKey`. */
const evictLargestRecoilState = (keepKey: string): number => {
  const biggest = recoilStateKeys()
    .filter((key) => key !== keepKey)
    .map((key) => ({ key, size: (storage().getItem(key) || "").length }))
    .sort((a, b) => b.size - a.size)[0];
  if (!biggest) return 0;
  storage().removeItem(biggest.key);
  return 1;
};

const isQuotaError = (error: unknown): boolean => {
  const name = (error as any)?.name || "";
  // Safari reports QUOTA_EXCEEDED_ERR / code 22; Firefox NS_ERROR_DOM_QUOTA_REACHED.
  return (
    name === "QuotaExceededError" ||
    name === "NS_ERROR_DOM_QUOTA_REACHED" ||
    name === "QUOTA_EXCEEDED_ERR" ||
    (error as any)?.code === 22
  );
};

const STORAGE_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes in milliseconds
const EXTENDED_STORAGE_EXPIRY_MS = 60 * 60 * 1000; // 1 hour in milliseconds

/**
 * Bumped when the on-disk shape changes in a way that makes older entries
 * unsafe to read. Entries without the current format are dropped on load.
 *
 * v2: values are stored as they are typed. v1 flattened a Dayjs to a bare ISO
 * string on save and relied on a blanket "re-parse anything ISO-looking" pass
 * on load to turn it back. That pass is gone, so a v1 entry would hand back a
 * string where the code expects a Dayjs — `searchStateAtom.outboundDate` is
 * one, and 52 call sites do `outboundDate.toISOString()` on it, which throws on
 * a string. Dropping v1 entries costs one cache miss; keeping them crashes the
 * train-offer page for anyone mid-session across the deploy.
 */
const STORAGE_FORMAT = 2;

interface StorageData {
  format: number;
  value: unknown;
  timestamp: number;
  expiresAt: number;
}

/**
 * Values are persisted AS THEY ARE TYPED.
 *
 * Both save and load used to recursively walk the whole object graph and turn
 * any string that looked like an ISO 8601 datetime into a Dayjs. Two problems:
 *
 *  - it lied about types. `booking.trips[].startTime` is declared `string` and
 *    IS a string in memory, but came back from a refresh as a Dayjs — so
 *    `startTime.split("T")` worked on first visit and threw after F5. 71
 *    distinct API field paths were affected, `validFrom`/`validUntil` and every
 *    `serviceDeparture`/`serviceArrival` time among them. `booking.ts`'s
 *    `dayjs.isDayjs(trip.startTime) ? … : String(…)` is a scar from it.
 *  - it cost two full recursive deep-clones per persist. On the ~2 MB payloads
 *    this app stores, save measured 10.2ms -> 2.8ms and load 8.6ms -> 3.3ms
 *    with the walks removed.
 *
 * Genuine Dayjs and Date values still round-trip: the replacer/reviver below
 * tag them explicitly. Nothing read the auto-converted strings as Dayjs — all
 * five call sites that use dayjs methods on these fields wrap them in `dayjs()`
 * first, which accepts either.
 */

export const saveAtomToStorage = (key: string, value: unknown) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const now = Date.now();


    // Create storage data with expiration metadata
    const expiryMs = extendedExpiryAtoms.includes(key) ? EXTENDED_STORAGE_EXPIRY_MS : STORAGE_EXPIRY_MS;
    const storageData: StorageData = {
      format: STORAGE_FORMAT,
      value,
      timestamp: now,
      expiresAt: now + expiryMs
    };

    // `function`, NOT an arrow: the replacer needs `this` (the holder) to reach
    // the value as it was BEFORE `toJSON()` ran.
    //
    // JSON.stringify calls toJSON() first and only then the replacer, so `val`
    // is already an ISO string by the time this runs. That made both
    // `dayjs.isDayjs(val)` and `val instanceof Date` permanently false — the
    // __type tags below were dead code, and a Dayjs survived a round-trip only
    // because the load side re-parsed every ISO-looking string back into one.
    // That blanket re-parse is gone (it also converted fields declared
    // `string`), so the tags have to actually work now.
    // `searchStateAtom.outboundDate` is a genuinely persisted Dayjs.
    const serializedValue = JSON.stringify(storageData, function (this: Record<string, unknown>, key: string, val: unknown) {
      const raw = this?.[key];
      if (dayjs.isDayjs(raw)) {
        return { __type: 'dayjs', __value: raw.toISOString() };
      }
      if (raw instanceof Date) {
        return { __type: 'date', __value: raw.toISOString() };
      }
      // A Dayjs that lost its prototype (spread, structured clone) arrives as a
      // plain object carrying the internals. It has no toJSON, so `val` is it.
      const plain = val as { $L?: unknown; $d?: unknown; _isAMomentObject?: boolean } | null;
      if (plain && typeof plain === 'object' &&
          ((plain.$L !== undefined && plain.$d !== undefined) || plain._isAMomentObject === true)) {
        return { __type: 'dayjs', __value: dayjs(plain.$d as Date).toISOString() };
      }
      return val;
    });

    try {
      storage().setItem(storageKey, serializedValue);
    } catch (error) {
      if (!isQuotaError(error)) throw error;
      // Full: reclaim and retry rather than dropping this write on the floor.
      if (evictExpiredRecoilState() > 0) {
        try {
          storage().setItem(storageKey, serializedValue);
          return;
        } catch (retryError) {
          if (!isQuotaError(retryError)) throw retryError;
        }
      }
      // Still no room: give up the largest survivors, one at a time, so the
      // smallest possible amount of recoverable state is sacrificed.
      for (let attempt = 0; attempt < 3; attempt++) {
        if (evictLargestRecoilState(storageKey) === 0) break;
        try {
          storage().setItem(storageKey, serializedValue);
          return;
        } catch (retryError) {
          if (!isQuotaError(retryError)) throw retryError;
        }
      }
      throw error;
    }
  } catch (error) {
    console.warn(`Failed to save ${key} to storage:`, error);
  }
};

export const loadAtomFromStorage = <T>(key: string): T | null => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const stored = storage().getItem(storageKey);

    if (!stored) return null;

    // Custom deserializer to handle Dayjs objects and other special types
    const parsedValue = JSON.parse(stored, (key, val) => {
      // Handle Dayjs objects
      if (val && typeof val === 'object' && val.__type === 'dayjs') {
        return dayjs(val.__value);
      }
      // Handle native Date objects
      if (val && typeof val === 'object' && val.__type === 'date') {
        return new Date(val.__value);
      }
      return val;
    });

    // Check if the parsed value has the new storage format with expiration
    if (
      parsedValue && typeof parsedValue === 'object' &&
      (parsedValue as StorageData).format === STORAGE_FORMAT &&
      'expiresAt' in parsedValue && 'value' in parsedValue
    ) {
      const storageData = parsedValue as StorageData;
      const now = Date.now();

      // Check if the data has expired
      if (now > storageData.expiresAt) {
        // Data has expired, remove it
        storage().removeItem(storageKey);
        return null;
      }

      // Data is still valid, return the actual value
      const actualValue = storageData.value;

      return actualValue as T;
    } else {
      // Written by an older storage format (or the pre-versioning shape with no
      // expiry at all). Not safe to read back — drop it and take the cache miss.
      storage().removeItem(storageKey);
      return null;
    }
  } catch (error) {
    console.warn(`Failed to load ${key} from storage:`, error);
    // If there's an error parsing, remove the corrupted data
    try {
      const storageKey = `${STORAGE_PREFIX}${key}`;
      storage().removeItem(storageKey);
    } catch (e) {
      // Ignore cleanup errors
    }
    return null;
  }
};

/**
 * Drop one atom's persisted entry.
 *
 * Exported so `clearBookingFlowAtoms` can reset an atom WITHOUT naming a
 * backing store. It used to call `window.localStorage.removeItem` directly, and
 * when persistence moved to sessionStorage that line silently stopped clearing
 * anything — the atom reset while its persisted copy survived to be restored by
 * the next `hydratePersistedAtoms`. `storage()` is the single place that knows
 * which Storage backs atom persistence; every remover has to go through it.
 */
export const removeFromStorage = (key: string) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    storage().removeItem(storageKey);
  } catch (error) {
    console.warn(`Failed to remove ${key} from storage:`, error);
  }
};

// O(1) membership check for the persistence whitelist (checked on every state
// write, and once per page load by hydratePersistedAtoms).
const whitelistedAtomSet = new Set(whitelistedAtoms);

// O(1) atom lookup. Built lazily on first use (the `atoms` array is defined
// further down in this module). Keeps the FIRST occurrence of a duplicated
// key to match the previous `atoms.find()` semantics.
let _atomsByKey: Map<string, (typeof atoms)[number]> | null = null;
function getAtomByKey(key: string) {
  if (!_atomsByKey) {
    _atomsByKey = new Map();
    for (const a of atoms) {
      // Skip holes rather than throw on `a.key`. `atoms` is assembled from ~30
      // modules and this map is built lazily on FIRST lookup, so a circular
      // import (or a jest module mock) that leaves one entry undefined took the
      // whole registry down — every updateRecoilState call, not just the
      // affected key.
      if (a && !_atomsByKey.has(a.key)) _atomsByKey.set(a.key, a);
    }
  }
  return _atomsByKey.get(key);
}

/**
 * Persist a whitelisted atom. Called synchronously from `updateRecoilState`.
 *
 * Replaces the old UPDATE_REC_STATE bus handler, which ran in a microtask and
 * was the ONLY writer of `bufferMap` / `atomValueCache` / localStorage. Those
 * two caches are gone: `appStore` is now the single source of truth, so a value
 * can no longer be "written" to one copy and read back from another.
 */
const persistIfWhitelisted = (key: string, value: unknown) => {
  if (whitelistedAtomSet.has(key) && !_suppressLocalStorageWrites) {
    saveAtomToStorage(key, value);
  }
};

const ATOMS = {
  endToEndSelectedTripAtom: endToEndSelectedTripAtom,
  rideHailingModeAtom: rideHailingModeAtom,
  rideSearchStateAtom: rideSearchStateAtom,
  rideEstimatesAtom: rideEstimatesAtom,
  rideResultsStatusAtom: rideResultsStatusAtom,
  rideLocationPickerAtom: rideLocationPickerAtom,
  rideHailingDisabledAtom: rideHailingDisabledAtom,
  carRentalModeAtom: carRentalModeAtom,
  carRentalSearchStateAtom: carRentalSearchStateAtom,
  carRentalLocationsAtom: carRentalLocationsAtom,
  carRentalResultsStatusAtom: carRentalResultsStatusAtom,
  carRentalV2SegmentsAtom: carRentalV2SegmentsAtom,
  shuttleBusModeAtom: shuttleBusModeAtom,
  shuttleSelectionAtom: shuttleSelectionAtom,
  shuttleStopsAtom: shuttleStopsAtom,
  shuttleTripsAtom: shuttleTripsAtom,
  shuttleOffersStatusAtom: shuttleOffersStatusAtom,
  shuttleMinPriceCacheAtom: shuttleMinPriceCacheAtom,
  shuttleStopAvailabilityAtom: shuttleStopAvailabilityAtom,
  refundedShuttleOfferIdsAtom: refundedShuttleOfferIdsAtom,
  shuttleAddedAtom: shuttleAddedAtom,
  shuttleAddRequestAtom: shuttleAddRequestAtom,
  nolCardModeAtom: nolCardModeAtom,
  nolSelectionAtom: nolSelectionAtom,
  nolAddedAtom: nolAddedAtom,
  nolOffersAtom: nolOffersAtom,
  appliedPassengerPassAtom: appliedPassengerPassAtom,
  passBookingsAtom: passBookingsAtom,
  multiBookingOfferResponseAtom: multiBookingOfferResponseAtom,
  multiBookingSelectedTrainsAtom: multiBookingSelectedTrainsAtom,
  multiBookingFormValuesAtom: multiBookingFormValuesAtom,
  multiBookingTravelDatesAtom: multiBookingTravelDatesAtom,
  multiBookingChangeTrainOffersAtom: multiBookingChangeTrainOffersAtom,
  newsLoadedAtom: newsLoadedAtom,
  routesLoadedAtom: routesLoadedAtom,
  popularTripsLoadedAtom: popularTripsLoadedAtom,
  popularDestinationsLoadedAtom: popularDestinationsLoadedAtom,
  // Reachable ONLY through the deleted `bufferMap` until now: its writer
  // (updateRecoilState) and its reader (getRecoilStateValue) both bypassed
  // Jotai, so the missing registry entry was invisible. Both go through the
  // store now, so the atom has to actually be in it.
  tiersConfigAtom: tiersConfigAtom
} as const;

type RecoilAtomMap = {
  [K in keyof typeof ATOMS]: typeof ATOMS[K] extends WritableAtom<infer T, any, any> ? T : never;
};

export const atoms: ReadonlyArray<WritableAtom<any, [any], void> & { key: string; initialValue?: unknown }> = [
  ...Object.values(ATOMS), // Dynamically add atoms from ATOMS
  testStringAtom,
  quickExchangeBookingResponseAtom,
  exchangeOffersAtom,
  stopsResponseAtom,
  mealResponseAtom,
  ticketOptionsAtom,
  seatingPreferencesAtom,
  isAuthenticatedStateAtom,
  isAnonymousStateAtom,
  tokenStateAtom,
  userProfileStateAtom,
  isAuthCheckCompleteStateAtom,
  initializedStateAtom,
  passengerTypesStateAtom,
  searchStateAtom,
  searchStatePopupAtom,
  userDataAtom,
  favoritesStateAtom,
  searchPopupDataAtom,
  languagesResponseAtom,
  selectedDateRangeStateAtom,
  calendarDayIntervalAtom,
  accountActionAtom,
  selectedTrainStateAtom,
  isSelectingOriginAtom,
  isSelectingDestinationAtom,
  isPassengerDropdownOpenAtom,
  languageDropdownOpenAtom,
  localeLanguageAtom,
  offerAtom,
  offerPassTypeAtom,
  offersPageViewAtom,
  selectedCmsPassOfferAtom,
  selectedPassOfferAtom,
  passOfferResponseAtom,
  passFormValuesAtom,
  selectedPassBookingAtom,
  cmsAboutPassDetailAtom,
  cmsAccountBannerAtom,
  upgradeOutboundOffersAtom,
  upgradeInboundOffersAtom,
  openSearchModalAtom,
  trainTypeAtom,
  availableDatesAtom,
  offersRequestAtom,
  filterStateAtom,
  selectedServiceClassAtom,
  trainAtom,
  startIndexDateSelectorAtom,
  filterTrainsAtom,
  visibleTrainsAtom,
  selectedOutboundTrainAtom,
  selectedInboundTrainAtom,
  selectedOfferIdAtom,
  selectedShuttleOfferIdAtom,
  outboundShuttleOfferIdAtom,
  originalTrainClassSelectionAtom,
  initialTrainClassSelectionAtom,
  ticketTypeStateAtom,
  passengerSpecificationsTypesAtom,
  paymentOutboundAtom,
  paymentOutboundRefundAtom,
  paymentInboundAtom,
  paymentInboundRefundAtom,
  activeAccountActionAtom,
  countryCodesAtom,
  selectedMenuAtom,
  updatedStopsAtom,
  subStationDropdownAtom,
  showInvoiceDetailsAtom,
  isPersonalInfoModifiedAtom,
  isPersonalInfoFormValidAtom,
  outboundOfferIdAtom,
  inboundSearchStateAtom,
  inboundOfferIdAtom,
  bookingRequestAtom,
  bookingResponseAtom,
  bookingScopeAtom,
  bookingDetailsRefreshTokenAtom,
  authLoadedStateAtom,
  accountProgressAtom,
  passengerStateAtom,
  selectedPassengersPerTypeStateAtom,
  customerContactStateAtom,
  savedPassengerDetailAtom,
  voucherCodeAtom,
  voucherErrorAtom,
  listOfAppliedVoucherAtom,
  promoCodeErrorAtom,
  listOfAppliedPromoCodeAtom,
  checkoutUserDataAtom,
  cookieConsentGivenAtom,
  cookieConsentBannerVisibleAtom,
  cookieManagementModalVisibleAtom,
  cookiePreferencesAtom,
  passengerMappingAtom,
  tripLegsDetailsAtom,
  areAllPassengerDetailsCompleteAtom,
  paymentStateAtom,
  carLicensePlateAtom,
  saveCardAtom,
  termsAgreedAtom,
  paymentSubmittingAtom,
  seatSelectorOpenAtom,
  selectedSeatsAtom,
  originalSeatsAtom,
  confirmedSeatsAtom,
  placeMapResponseAtom,
  locationPermissionStateAtom,
  coachLayoutResponseAtom,
  floorPlanIconsResponseAtom,
  seatServiceClassAtom,
  seatTravelClassAtom,
  selectedCoachAtom,
  unavailableSeatsAtom,
  seatsChangedOnCheckoutAtom,
  initiallyAvailableSeatsAtom,
  isAddShuttleAtom,
  outboundShuttleState,
  inboundShuttleState,
  selectedPassengerForCancelAtom,
  trainShuttleBookingAtom,
  shuttleBookedOffersAtom,
  selectedShuttlesAtom,
  bookedTripsAtom,
  upcomingMultiBookingTripsAtom,
  pastMultiBookingTripsAtom,
  isModalVisibleAtom,
  isRoundTripModalVisibleAtom,
  isRoundTripInboundModalVisibleAtom,
  calendarStateAtom,
  selectedTripForBookItAgainAtom,
  selectedPassengerForCancelInBoundAtom,
  fulfillmentResponseAtom,
  selectedTrainLegsAtom,
  tripOfferAtom,
  passengerSeatCursorAtom,
  sliderStationFacilitiesDataStateAtom,
  allPassengerPriceAndAgeGroupAtom,
  bookedNextTripsAtom,
  activeBookingTabAtom,
  bookingsListPaginationAtom,
  allPassengerPriceAndAgeGroupInBoundAtom,
  currentPassengerTicketAtom,
  currentOfferIndexTicketAtom,
  currentLegIndexTicketAtom,
  modalStateTicketAtom,
  modalStateRequestInvoiceAtom,
  selectedInboundTrainStateAtom,
  checkoutPaymentSummaryAtom,
  nextAndPreviousTrainAtom,
  lastMonthAtom,
  retrieveFormAtom,
  isPastBookingDetailsAtom,
  bookingConfirmStatusAtom,
  isHyperFastStateAtom,
  isQuickExchangeStateAtom,
  selectedDateAtom,
  inboundSelectedDateAtom,
  selectedPassengersAtom,
  selectedBookingIdForCancelAtom,
  cancelBookingPreviousRouteAtom,
  upgradePreviousRouteAtom,
  tripDisableForCancelSelectionAtom,
  selectedBookingTripStatusAtom,
  selectedPassengersOutBoundAtom,
  selectedPassengersInBoundAtom,
  paymentOutBoundItemsDetailsAtom,
  cancelBookingConfirmPopupFlagAtom,
  paymentInboundItemsDetailsAtom,
  alreadyPaidOutBoundAtom,
  alreadyPaidInBoundAtom,
  repeatedBookingAtom,
  calendarBestPriceAtom,
  selectedPassengerForDateChangeAtom,
  selectedPassengerForDateChangeInBoundAtom,
  selectedBookingIdForDateChangeAtom,
  tripDisableForDateChangeSelectionAtom,
  outboundProductCodeAtom,
  inboundProductCodeAtom,
  isShuttleChangeDateAtom,
  inboundSelectedChangeDateAtom,
  selectedChangeDateAtom,
  SelectedOfferIdChangeDateAtom,
  selectedRangeStateAtom,
  isChangeDateStateAtom,
  displayPassengerDataAtom,
  isRetrieveModalOpenAtom,
  selectedTripsDataAtom,
  showRetrieveBookingAtom,
  modificationNotAllowedBookingIdsAtom,
  autoSuggestionListAtom,
  offerCalendarBestPriceAtom,
  markSelectedDateAsDisableAtom,
  dateSelectedFromCalendarAtom,
  selectedDatePriceAtom,
  isDateOfferCheckDoneAtom,
  markSelectedDateAsSoldOutAtom,
  calendarRangeBestPriceAtom,
  locationMapVisibleAtom,
  locationDataAtom,
  selectedLocationAtom,
  fmlmSubStationDropdownAtom,
  selectedLocationDestinationAtom,
  fmlmReverseGeoCodeLocationAtom,
  currentLocationAtom,
  fetchingFmlmViewInformationAtom,
  fmlmViewInformationAtom,
  fmlmViewOffersMapAtom,
  lastFmlmFetchOfferDateAtom,
  fmlmFilterAtom,
  isDepartureDateChangedAtom,
  selectedFmlmJourneyAtom,
  selectedInboundFmlmJourneyAtom,
  isTimerVisibleAtom,
  isFmlmFilterTimerModelOpenAtom,
  isFmlmInboundTimeModalOpenAtom,
  pendingBookingDataAtom,
  guestCheckoutBookingIdAtom,
  selectedBookingForBookItAgainAtom,
  originalPriceOfExchangedItemsOutboundAtom,
  originalPriceOfExchangedItemsInboundAtom,
  refundOfferResponseAtom,
  refundFeeAtom,
  refundableAmountAtom,
  refundQuoteFailedAtom,
  getAppBanner,
  selectOsInfo,
  selectFaqAtom,
  contactCategoriesAtom,
  selectFaqLoading,
  fmlmFavouriteLocationAtom,
  isOtpVerifiedAtom,
  phoneVerificationResponseAtom,
  otpErrorAtom,
  isManageSeatingAtom,
  fmlmJourneyResponseAtom,
  paymentSuccessModalAtom,
  selectedTripForServiceRequestAtom,
  selectedCategoryAndSubCategoryAtom,
  serviceCategoriesAtom,
  subServiceCategoriesAtom,
  serviceRequestFormDataAtom,
  submitRequestButtonDisabledAtom,
  saveServiceRequestResponseAtom,
  serviceRequestModalAtom,
  destinationResponseAtom,
  cmsOfferListAtom,
  cmsOfferDetailAtom,
  cmsMonthlyPassOfferResponseAtom,
  cmsTravelPassOfferResponseAtom,
  cmsSpecialFareOfferResponseAtom,
  cmsSpecialFareOfferDetailResponseAtom,
  cmsPLaceDetailAtom,
  cmsAppDownloadLinkResponseAtom,
  cmsServiceClassFeatureListAtom,
  cmsProductFeatureListAtom,
  appDownloadLinkAtom,
  destinationDetailAtom,
  termsofUseContentResponseAtom,
  privacyPolicyContentResponseAtom,
  usefulInformationAtom,
  routesResponseAtom,
  trustBuildersResponseAtom,
  newsListResponseAtom,
  newsDetailResponseAtom,
  bannerListResponseAtom,
  serviceRequestTicketListAtom,
  openActionModalAtom,
  actionTypeAtom,
  openCommentAtom,
  bookingResponseListAtom,
  activeTicketAtom,
  activitiesSectorsAtom,
  citiesAtom,
  requestCorporateAccountDetailsAtom,
  corporateFormSubmittedAtom,
  corporateDataAtom,
  corporateUsersAtom,
  activeCompanyActionAtom,
  corporateLoadingAtom,
  corporateLoadErrorAtom,
  corporateUsersLoadErrorAtom,
  corporateUsersTotalAtom,
  companyBookingsAtom,
  companyBookingsTotalAtom,
  companyBookingsLoadingAtom,
  companyBookingsLoadErrorAtom,
  selectCorporateAccountFaqAtom,
  corporateAccountFlowStartedAtom,
  networkMapStationResponseAtom,
  networkDetailResponseAtom,
  networkMapStationInfoResponseAtom,
  journeyPlannerStationAtom,
  journeyPlannerContentAtom,
  popularTripsPriceAtom,
  contentDetailAtom,
  defaultActiveKeyForTripSummaryAtom,
  lastVisitedPageForServiceRequestAtom,
  isUpgradeToPremiumStateAtom,
  mealPreferencesResponseAtom,
  showAddonsModalAtom,
  addonsPassengerListAtom,
  selectedLegAddonsPriceAtom,
  confirmAddonsPassengerListAtom,
  alreadyAddonsLegPassengerAtom,
  changeTripAlreadyPaidAddonsAtom,
  quickExchangeTripDirectionAtom,
  alreadyAddonsLegPassengerTotalAtom,
  manageAddonsNewConfirmedAddonsAtom,
  manageAddonsRemovedAddonsAtom,
  patchAddonsOnConfirmAtom,
  bookingLegWiseAddonsForCancelTripAtom,
  addonFlowStartedAtom,
  carriedOverAddonsAtom,
  changeDateCarryOverSnapshotAtom,
  manageSeatingBaselineAddonsLegPassengerAtom,
  pendingRefundFulfillmentIdsAtom,
  refundOffersByFulfillmentIdAtom,
  additionalFieldsAtom,
  modifiedPassengerNameAtom,
  selectedBookingIdForBookReturnJourneyAtom,
  selectedBookReturnJourneyDateAtom,
  isBookReturnJourneyAtom,
  bookedCommentsResponseAtom,
  bookedJourneyCommentAtom,
  journeyPlannerStateAtom,
  journeyPlannerTrainTypeTabAtom,
  allFmlmJourneyAtom,
  manageIncludeWidgetsAtom,
  manageWidgetsAtom,
  experienceFieldsAtom,
  favoriteDepartureFieldsAtom,
  favoriteTripsForTodayFieldsAtom,
  multiBookingPreferenceBackToAtom,
  subActiveAccountActionAtom,
  bookingsSearchResponseAtom,
  personalizeExperienceActiveTabAtom,
  generalFieldsAtom,
  specialAssistancePrefAtom,
  travelsDaysAtom,
  enhancedTripsResponseAtom,
  voucherDataAtom,
  bookingPaymentDataAtom,
  favouriteTripsForTodayResponseAtom,
  favouriteDeparturesForTodayResponseAtom,
  enhancedTripDetailAtom,
  popularTripsForHomePageAtom,
  bestPriceAvailableOriginsAtom,
  usefulInfoDetailAtom,
  departureFromTripsAtom,
  todayTrainFromTripsAtom,
  cmsStopsAtom,
  isAddShuttleFlowAtom,
  earnPointsAtom,
  earnExtraPointsAtom,
  earnPointsTotalAtom,
  earnPointsOutboundAtom,
  earnPointsInboundAtom,
  loyaltyTiersAtom,
  customerLoyaltyTierRateAtom,
  cmsGroupBookingAtom,
  isStandardPrivacySeatingCheckedAtom,
  isPremiumPrivacySeatingCheckedAtom,
  selectedStandardPrivacySeatingOutboundAtom,
  selectedStandardPrivacySeatingInboundAtom,
  selectedPremiumPrivacySeatingOutboundAtom,
  selectedPremiumPrivacySeatingInboundAtom,
  loyaltyProgramResponseAtom,
  paymentCardsAtom,
  voucherDetailAtom,
  isMultiBookingStateAtom,
  multiBookingRefundSummaryAtom,
  trainScheduleDataAtom,
  loyaltyProgramDataAtom,
  cmsAboutLoyaltyProgramResponseAtom,
  loyaltyCardHandleSelectActionAtom,
  customerTiersDataAtom
];

export type TAtomList =
  | keyof RecoilAtomMap
  | "testStringAtom"
  | "addonFlowStartedAtom"
  | "bookingLegWiseAddonsForCancelTripAtom"
  | "manageAddonsNewConfirmedAddonsAtom"
  | "manageAddonsRemovedAddonsAtom"
  | "patchAddonsOnConfirmAtom"
  | "modifiedPassengerNameAtom"
  | "additionalFieldsAtom"
  | "sliderStationFacilitiesDataStateAtom"
  | "quickExchangeTripDirectionAtom"
  | "alreadyAddonsLegPassengerTotalAtom"
  | "lastVisitedPageForServiceRequestAtom"
  | "changeTripAlreadyPaidAddonsAtom"
  | "alreadyAddonsLegPassengerAtom"
  | "changeDateCarryOverSnapshotAtom"
  | "manageSeatingBaselineAddonsLegPassengerAtom"
  | "pendingRefundFulfillmentIdsAtom"
  | "refundOffersByFulfillmentIdAtom"
  | "initialTrainClassSelectionAtom"
  | "confirmAddonsPassengerListAtom"
  | "selectedLegAddonsPriceAtom"
  | "addonsPassengerListAtom"
  | "showAddonsModalAtom"
  | "mealPreferencesResponseAtom"
  | "selectCorporateAccountFaqAtom"
  | "corporateAccountFlowStartedAtom"
  | "activeTicketAtom"
  | "bookingResponseListAtom"
  | "actionTypeAtom"
  | "openCommentAtom"
  | "openActionModalAtom"
  | "serviceRequestTicketListAtom"
  | "selectedTripForServiceRequestAtom"
  | "serviceRequestModalAtom"
  | "saveServiceRequestResponseAtom"
  | "submitRequestButtonDisabledAtom"
  | "serviceRequestFormDataAtom"
  | "selectedCategoryAndSubCategoryAtom"
  | "serviceCategoriesAtom"
  | "subServiceCategoriesAtom"
  | "guestCheckoutBookingIdAtom"
  | "markSelectedDateAsSoldOutAtom"
  | "isDateOfferCheckDoneAtom"
  | "selectedDatePriceAtom"
  | "dateSelectedFromCalendarAtom"
  | "markSelectedDateAsDisableAtom"
  | "autoSuggestionListAtom"
  | "calendarBestPriceAtom"
  | "requestCorporateAccountDetailsAtom"
  | "citiesAtom"
  | "nextAndPreviousTrainAtom"
  | "tripOfferAtom"
  | "stopsResponseAtom"
  | "mealResponseAtom"
  | "ticketOptionsAtom"
  | "seatingPreferencesAtom"
  | "quickExchangeBookingResponseAtom"
  | "isAuthenticatedStateAtom"
  | "isAnonymousStateAtom"
  | "tokenStateAtom"
  | "userProfileStateAtom"
  | "isAuthCheckCompleteStateAtom"
  | "initializedStateAtom"
  | "authLoadedStateAtom"
  | "passengerTypesStateAtom"
  | "searchStateAtom"
  | "selectedTripForBookItAgainAtom"
  | "searchStatePopupAtom"
  | "userDataAtom"
  | "favoritesStateAtom"
  | "searchPopupDataAtom"
  | "languagesResponseAtom"
  | "selectedDateRangeStateAtom"
  | "calendarDayIntervalAtom"
  | "accountActionAtom"
  | "isSelectingOriginAtom"
  | "isSelectingDestinationAtom"
  | "isPassengerDropdownOpenAtom"
  | "languageDropdownOpenAtom"
  | "localeLanguageAtom"
  | "offerAtom"
  | "offerPassTypeAtom"
  | "offersPageViewAtom"
  | "selectedCmsPassOfferAtom"
  | "selectedPassOfferAtom"
  | "passOfferResponseAtom"
  | "passFormValuesAtom"
  | "selectedPassBookingAtom"
  | "cmsAboutPassDetailAtom"
  | "cmsAccountBannerAtom"
  | "openSearchModalAtom"
  | "upgradeOutboundOffersAtom"
  | "upgradeInboundOffersAtom"
  | "trainTypeAtom"
  | "availableDatesAtom"
  | "offersRequestAtom"
  | "filterStateAtom"
  | "selectedServiceClassAtom"
  | "trainAtom"
  | "startIndexDateSelectorAtom"
  | "filterTrainsAtom"
  | "visibleTrainsAtom"
  | "selectedOutboundTrainAtom"
  | "selectedInboundTrainAtom"
  | "selectedOfferIdAtom"
  | "originalTrainClassSelectionAtom"
  | "ticketTypeStateAtom"
  | "passengerSpecificationsTypesAtom"
  | "paymentOutboundAtom"
  | "paymentOutboundRefundAtom"
  | "paymentInboundAtom"
  | "paymentInboundRefundAtom"
  | "selectedShuttleOfferIdAtom"
  | "activeAccountActionAtom"
  | "countryCodesAtom"
  | "selectedMenuAtom"
  | "updatedStopsAtom"
  | "subStationDropdownAtom"
  | "showInvoiceDetailsAtom"
  | "isPersonalInfoModifiedAtom"
  | "isPersonalInfoFormValidAtom"
  | "outboundOfferIdAtom"
  | "inboundSearchStateAtom"
  | "inboundOfferIdAtom"
  | "bookingRequestAtom"
  | "bookingResponseAtom"
  | "bookingScopeAtom"
  | "bookingDetailsRefreshTokenAtom"
  | "accountProgressAtom"
  | "passengerStateAtom"
  | "selectedPassengersPerTypeStateAtom"
  | "customerContactStateAtom"
  | "savedPassengerDetailAtom"
  | "locationPermissionStateAtom"
  | "voucherCodeAtom"
  | "voucherErrorAtom"
  | "listOfAppliedVoucherAtom"
  | "promoCodeErrorAtom"
  | "listOfAppliedPromoCodeAtom"
  | "checkoutUserDataAtom"
  | "passengerMappingAtom"
  | "tripLegsDetailsAtom"
  | "areAllPassengerDetailsCompleteAtom"
  | "paymentStateAtom"
  | "carLicensePlateAtom"
  | "saveCardAtom"
  | "termsAgreedAtom"
  | "paymentSubmittingAtom"
  | "seatSelectorOpenAtom"
  | "selectedSeatsAtom"
  | "placeMapResponseAtom"
  | "coachLayoutResponseAtom"
  | "floorPlanIconsResponseAtom"
  | "seatServiceClassAtom"
  | "seatTravelClassAtom"
  | "selectedCoachAtom"
  | "unavailableSeatsAtom"
  | "seatsChangedOnCheckoutAtom"
  | "initiallyAvailableSeatsAtom"
  | "isAddShuttleAtom"
  | "outboundShuttleState"
  | "inboundShuttleState"
  | "selectedPassengerForCancelAtom"
  | "bookedTripsAtom"
  | "upcomingMultiBookingTripsAtom"
  | "pastMultiBookingTripsAtom"
  | "isModalVisibleAtom"
  | "isRoundTripModalVisibleAtom"
  | "calendarStateAtom"
  | "fulfillmentResponseAtom"
  | "selectedTrainLegsAtom"
  | "passengerSeatCursorAtom"
  | "bookedNextTripsAtom"
  | "activeBookingTabAtom"
  | "bookingsListPaginationAtom"
  | "currentPassengerTicketAtom"
  | "currentOfferIndexTicketAtom"
  | "currentLegIndexTicketAtom"
  | "modalStateRequestInvoiceAtom"
  | "outboundShuttleOfferIdAtom"
  | "inboundSelectedDateAtom"
  | "selectedInboundTrainStateAtom"
  | "lastMonthAtom"
  | "retrieveFormAtom"
  | "isPastBookingDetailsAtom"
  | "isHyperFastStateAtom"
  | "isQuickExchangeStateAtom"
  | "bookingConfirmStatusAtom"
  | "checkoutPaymentSummaryAtom"
  | "isRoundTripInboundModalVisibleAtom"
  | "modalStateTicketAtom"
  | "trainShuttleBookingAtom"
  | "selectedTrainStateAtom"
  | "selectedPassengerForCancelInBoundAtom"
  | "selectedDateAtom"
  | "selectedPassengersAtom"
  | "selectedBookingIdForCancelAtom"
  | "cancelBookingPreviousRouteAtom"
  | "upgradePreviousRouteAtom"
  | "allPassengerPriceAndAgeGroupAtom"
  | "allPassengerPriceAndAgeGroupInBoundAtom"
  | "tripDisableForCancelSelectionAtom"
  | "selectedBookingTripStatusAtom"
  | "selectedPassengersOutBoundAtom"
  | "selectedPassengersInBoundAtom"
  | "paymentOutBoundItemsDetailsAtom"
  | "cancelBookingConfirmPopupFlagAtom"
  | "paymentInboundItemsDetailsAtom"
  | "alreadyPaidOutBoundAtom"
  | "repeatedBookingAtom"
  | "exchangeOffersAtom"
  | "alreadyPaidInBoundAtom"
  | "selectedPassengerForDateChangeAtom"
  | "selectedPassengerForDateChangeInBoundAtom"
  | "selectedBookingIdForDateChangeAtom"
  | "tripDisableForDateChangeSelectionAtom"
  | "outboundProductCodeAtom"
  | "inboundProductCodeAtom"
  | "isShuttleChangeDateAtom"
  | "inboundSelectedChangeDateAtom"
  | "selectedChangeDateAtom"
  | "SelectedOfferIdChangeDateAtom"
  | "selectedRangeStateAtom"
  | "isChangeDateStateAtom"
  | "displayPassengerDataAtom"
  | "isRetrieveModalOpenAtom"
  | "selectedTripsDataAtom"
  | "showRetrieveBookingAtom"
  | "modificationNotAllowedBookingIdsAtom"
  | "calendarRangeBestPriceAtom"
  | "locationMapVisibleAtom"
  | "locationDataAtom"
  | "selectedLocationAtom"
  | "fmlmSubStationDropdownAtom"
  | "selectedLocationDestinationAtom"
  | "fmlmReverseGeoCodeLocationAtom"
  | "currentLocationAtom"
  | "fetchingFmlmViewInformationAtom"
  | "fmlmViewInformationAtom"
  | "fmlmViewOffersMapAtom"
  | "lastFmlmFetchOfferDateAtom"
  | "fmlmFilterAtom"
  | "isDepartureDateChangedAtom"
  | "selectedFmlmJourneyAtom"
  | "selectedInboundFmlmJourneyAtom"
  | "isTimerVisibleAtom"
  | "isFmlmFilterTimerModelOpenAtom"
  | "isFmlmInboundTimeModalOpenAtom"
  | "pendingBookingDataAtom"
  | "selectedBookingForBookItAgainAtom"
  | "originalPriceOfExchangedItemsOutboundAtom"
  | "getAppBanner"
  | "selectOsInfo"
  | "selectFaqAtom"
  | "contactCategoriesAtom"
  | "selectFaqLoading"
  | "offerCalendarBestPriceAtom"
  | "isOtpVerifiedAtom"
  | "phoneVerificationResponseAtom"
  | "otpErrorAtom"
  | "fmlmFavouriteLocationAtom"
  | "originalPriceOfExchangedItemsInboundAtom"
  | "refundOfferResponseAtom"
  | "refundFeeAtom"
  | "refundableAmountAtom"
  | "refundQuoteFailedAtom"
  | "isManageSeatingAtom"
  | "originalSeatsAtom"
  | "confirmedSeatsAtom"
  | "fmlmJourneyResponseAtom"
  | "paymentSuccessModalAtom"
  | "destinationResponseAtom"
  | "cmsOfferListAtom"
  | "cmsOfferDetailAtom"
  | "cmsMonthlyPassOfferResponseAtom"
  | "cmsTravelPassOfferResponseAtom"
  | "cmsSpecialFareOfferResponseAtom"
  | "cmsSpecialFareOfferDetailResponseAtom"
  | "cmsPLaceDetailAtom"
  | "cmsAppDownloadLinkResponseAtom"
  | "cmsServiceClassFeatureListAtom"
  | "cmsProductFeatureListAtom"
  | "appDownloadLinkAtom"
  | "destinationDetailAtom"
  | "usefulInformationAtom"
  | "routesResponseAtom"
  | "trustBuildersResponseAtom"
  | "newsListResponseAtom"
  | "newsDetailResponseAtom"
  | "bannerListResponseAtom"
  | "termsofUseContentResponseAtom"
  | "privacyPolicyContentResponseAtom"
  | "cookieConsentGivenAtom"
  | "cookieConsentBannerVisibleAtom"
  | "cookieManagementModalVisibleAtom"
  | "cookiePreferencesAtom"
  | "activitiesSectorsAtom"
  | "corporateFormSubmittedAtom"
  | "corporateDataAtom"
  | "corporateUsersAtom"
  | "activeCompanyActionAtom"
  | "corporateLoadingAtom"
  | "corporateLoadErrorAtom"
  | "corporateUsersLoadErrorAtom"
  | "corporateUsersTotalAtom"
  | "companyBookingsAtom"
  | "companyBookingsTotalAtom"
  | "companyBookingsLoadingAtom"
  | "companyBookingsLoadErrorAtom"
  | "networkMapStationResponseAtom"
  | "networkDetailResponseAtom"
  | "networkMapStationInfoResponseAtom"
  | "journeyPlannerStationAtom"
  | "journeyPlannerContentAtom"
  | "popularTripsPriceAtom"
  | "contentDetailAtom"
  | "defaultActiveKeyForTripSummaryAtom"
  | "isUpgradeToPremiumStateAtom"
  | "activitiesSectorsAtom"
  | "corporateFormSubmittedAtom"
  | "sliderStationFacilitiesDataStateAtom"
  | "selectedBookingIdForBookReturnJourneyAtom"
  | "selectedBookReturnJourneyDateAtom"
  | "isBookReturnJourneyAtom"
  | "bookedCommentsResponseAtom"
  | "bookedJourneyCommentAtom"
  | "journeyPlannerStateAtom"
  | "journeyPlannerTrainTypeTabAtom"
  | "allFmlmJourneyAtom"
  | "manageIncludeWidgetsAtom"
  | "manageWidgetsAtom"
  | "experienceFieldsAtom"
  | "favoriteDepartureFieldsAtom"
  | "favoriteTripsForTodayFieldsAtom"
  | "multiBookingPreferenceBackToAtom"
  | "subActiveAccountActionAtom"
  | "bookingsSearchResponseAtom"
  | "personalizeExperienceActiveTabAtom"
  | "generalFieldsAtom"
  | "specialAssistancePrefAtom"
  | "travelsDaysAtom"
  | "enhancedTripsResponseAtom"
  | "voucherDataAtom"
  | "bookingPaymentDataAtom"
  | "favouriteTripsForTodayResponseAtom"
  | "favouriteDeparturesForTodayResponseAtom"
  | "enhancedTripDetailAtom"
  | "popularTripsForHomePageAtom"
  | "bestPriceAvailableOriginsAtom"
  | "usefulInfoDetailAtom"
  | "departureFromTripsAtom"
  | "todayTrainFromTripsAtom"
  | "cmsStopsAtom"
  | "shuttleBookedOffersAtom"
  | "selectedShuttlesAtom"
  | "isAddShuttleFlowAtom"
  | "earnPointsAtom"
  | "earnExtraPointsAtom"
  | "earnPointsTotalAtom"
  | "earnPointsOutboundAtom"
  | "earnPointsInboundAtom"
  | "loyaltyTiersAtom"
  | "customerLoyaltyTierRateAtom"
  | "cmsGroupBookingAtom"
  | "isStandardPrivacySeatingCheckedAtom"
  | "isPremiumPrivacySeatingCheckedAtom"
  | "selectedStandardPrivacySeatingOutboundAtom"
  | "selectedStandardPrivacySeatingInboundAtom"
  | "selectedPremiumPrivacySeatingOutboundAtom"
  | "selectedPremiumPrivacySeatingInboundAtom"
  | "loyaltyProgramResponseAtom"
  | "tiersConfigAtom"
  | "paymentCardsAtom"
  | "voucherDetailAtom"
  | "isMultiBookingStateAtom"
  | "multiBookingRefundSummaryAtom"
  | "trainScheduleDataAtom"
  | "loyaltyProgramDataAtom"
  | "cmsAboutLoyaltyProgramResponseAtom"
  | "loyaltyCardHandleSelectActionAtom"
  | "customerTiersDataAtom"
  | "carriedOverAddonsAtom"
  | "nolCardModeAtom"
  | "nolSelectionAtom"
  | "nolAddedAtom"
  | "nolOffersAtom";

/**
 * Subscribe to an atom. Nothing more.
 *
 * The mount effect this used to carry re-read localStorage on EVERY mount of
 * EVERY component using a persisted key and wrote the result back into the
 * atom. Two consequences, both gone:
 *
 *  - it clobbered fresher in-memory state. Anything written with a bare
 *    `appStore.set` (which never reached localStorage) was silently reverted
 *    the next time a component using that key mounted;
 *  - it re-parsed the stored blob each time. `offerAtom` was measured at 3.0 MB
 *    on INT — a 3 MB JSON.parse plus a full recursive date-walk, synchronously,
 *    per mount.
 *
 * Restoring persisted values is now a single pass at page load; see
 * `hydratePersistedAtoms`.
 */
export function useRecState<T>(key: TAtomList) {
  return useAtom<T, [T], void>(getAtomByKey(key) as WritableAtom<T, [T], void>);
}

type RecState<K extends keyof RecoilAtomMap> = [
  RecoilAtomMap[K],
  (value: RecoilAtomMap[K]) => void
];

export function useRecStateWithType<K extends keyof RecoilAtomMap>(key: K): RecState<K> {
  return useRecState<RecoilAtomMap[K]>(key);
}

/**
 * Write an atom, and persist it if it is whitelisted. Fully synchronous.
 *
 * The old implementation set the store and ALSO emitted UPDATE_REC_STATE, whose
 * handler ran in a microtask and owned the only writes to `bufferMap`,
 * `atomValueCache` and localStorage. That split is what made a bare
 * `appStore.set` behave differently from this function, and it is gone: a bare
 * set now differs only in that it skips persistence.
 */
export function updateRecoilState<T>(key: TAtomList, value: T) {
  const jotaiAtom = getAtomByKey(key) as WritableAtom<T, [T], void> | undefined;
  if (!jotaiAtom) {
    // Previously this landed in `bufferMap` and read back fine, so a key missing
    // from the `atoms` registry was undetectable — that is exactly how
    // `tiersConfigAtom` shipped unregistered. Make the drift loud instead.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error(`[Recoil] "${key}" is not in the atoms registry — write dropped.`);
    }
    return;
  }
  appStore.set(jotaiAtom, value);
  persistIfWhitelisted(key, value);
}

export function updateRecoilStateWithType<K extends keyof RecoilAtomMap>(
  key: K,
  value: RecoilAtomMap[K]
): void {
  updateRecoilState(key, value);
}

/**
 * Synchronously read an atom's current value from anywhere (Actions, Flows).
 *
 * This used to read `bufferMap` / `atomValueCache` and NEVER the atom, so every
 * non-React reader could disagree with what the screen was rendering. It reads
 * the store now, which is the same value `useRecState` gives a component.
 *
 * `defaultValue` applies only when the key is not in the registry; a registered
 * atom that was never written returns its own declared default. All three call
 * sites that pass one pass a value identical to that default.
 */
export function getRecoilStateValue<T>(key: TAtomList, defaultValue?: T): T | undefined {
  const jotaiAtom = getAtomByKey(key);
  return jotaiAtom ? (appStore.get(jotaiAtom) as T) : defaultValue;
}

export function getRecoilStateValueWithType<K extends keyof RecoilAtomMap>(key: K, defaultValue?: RecoilAtomMap[K]): RecoilAtomMap[K] | undefined {
  return getRecoilStateValue<RecoilAtomMap[K]>(key, defaultValue);
}

if (typeof window !== "undefined") {
  (window as any).__getRecoilStateValue = (key: TAtomList, defaultValue?: unknown) => {
    return getRecoilStateValue(key, defaultValue);
  };
}

export const clearAllWhitelistedAtomsFromStorage = async (): Promise<void> => {
  try {
    whitelistedAtoms.forEach(async (atomKey) => {
      const storageKey = `${STORAGE_PREFIX}${atomKey}`;
      storage().removeItem(storageKey);
    });
    console.info("[Recoil] Cleared all whitelisted atoms from storage");
  } catch (error) {
    console.warn("Failed to clear whitelisted atoms from storage:", error);
  }
};

/**
 * Restore every persisted atom from localStorage. Call ONCE per page load.
 *
 * Replaces the per-mount effect that used to live in `useRecState`.
 *
 * Deliberately NOT run at module scope. The app is `dynamic = "force-dynamic"`,
 * so these `"use client"` pages are server-rendered and then hydrated by React;
 * restoring atoms before the first client render would make that render
 * disagree with the server HTML. It has to happen after hydration, which is why
 * the root provider calls it from a `useLayoutEffect` — that runs before every
 * passive effect in the tree, so it is strictly earlier than the per-mount
 * effect it replaces, and before the browser paints.
 */
export function hydratePersistedAtoms(): void {
  if (typeof window === "undefined") return;
  // Migration sweep: this state used to live in localStorage. Nothing reads
  // those keys now, so if we do not remove them here the old token and
  // passenger PII stay there forever.
  purgeLegacyLocalStorageState();
  for (const key of whitelistedAtomSet) {
    const jotaiAtom = getAtomByKey(key);
    if (!jotaiAtom) continue;
    try {
      const storedValue = loadAtomFromStorage(key);
      if (storedValue !== null) appStore.set(jotaiAtom, storedValue);
    } catch (error) {
      console.warn(`[Recoil] Failed to restore ${key}; clearing corrupted entry:`, error);
      removeFromStorage(key);
    }
  }
}
